import React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { SettingsStyles } from '../../../styles/CommonStyles';
import { SiteSettingsForServerAdminProps } from '../site-settings/ReactSiteSettingsForServerAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';

export type WebAuthoringSectionProps = SiteSettingsForServerAdminProps<'authoringEnabled' | 'webEditingEnabled'>;

export function WebAuthoringSection(props: WebAuthoringSectionProps) {
  const flowsWebeditingFeatureEnabled = FeatureFlags.MaestroFlowEditingServerV1;

  return <SettingsSection title={ Messages.webAuthoring()} description={Messages.webAuthoringDetails()}>
    <div className={SettingsStyles.checkboxGroup}>
      <FormikCheckbox
        name={'settings.authoringEnabled'}
        testId='allow-web-authoring-checkbox'
        label={Messages.settingsAllowWebAuthoring()}
      />
      {flowsWebeditingFeatureEnabled &&
        <FormikCheckbox
          name={'settings.webEditingEnabled'}
          testId='allow-flow-web-authoring-checkbox'
          label={Messages.settingsAllowFlowWebAuthoring()}
        />
      }
    </div>
  </SettingsSection>;
}

/**
 * Specs for registering the component in the settings registry
 */
export const WebAuthoringSpecs = componentRegistryEntry({
  name: 'WebAuthoringSection',
  component: WebAuthoringSection
});
